<script setup>
import CartWidget from "@/components/CartWidget.vue";

import { useCartStore } from "@/stores/CartStore";
import { useProductStore } from "@/stores/ProductStore";

const cartStore = useCartStore();
const productStore = useProductStore();

const currentUrl = window.location.pathname;

import {modalStore} from "./stores/ModalStore";

// cartStore.syncCart(currentUrl);
</script>

<template>
    <CartWidget />
</template>
